// Shared helpers for student authentication. Token is stored in localStorage
// under `mw_student_token`. Use `studentApi` for any authed API calls.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mw_student_token";

export const getStudentToken = () => {
    try {
        return localStorage.getItem(TOKEN_KEY) || null;
    } catch (e) {
        return null;
    }
};

export const setStudentToken = (token) => {
    try {
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
    } catch (e) {}
};

export const studentApi = axios.create({ baseURL: API });

studentApi.interceptors.request.use((config) => {
    const token = getStudentToken();
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export const isStudentLoggedIn = () => !!getStudentToken();
